import MatchEvent from '../interfaces/matchEvent';

export default function (matchEvents: MatchEvent[]): Array<number> {
  const liveFeedInternalIds: Array<number> = [];
  matchEvents.forEach((matchEvent) => {
    if (matchEvent.liveFeedSerialId) {
      liveFeedInternalIds.push(matchEvent.liveFeedSerialId);
    }
  });
  return liveFeedInternalIds;
}
